module.exports = __webpack_public_path__ + "static/media/bg_03.d3d377cd.jpg";